export const EVENTS_PAGE = {
  title: "Agenda des événements",
  eyebrow: "Sortir dans la commune",
  description:
    "Retrouvez les prochains événements, animations, rencontres et temps forts publiés par la commune.",
  heroImageUrl:
    "https://www.ville-courbevoie.fr/Files/2/8/csm_agenda_a857ebcc53.jpg",
  crumbs: [
    { label: "Accueil", href: "/" },
    { label: "Ma Ville" },
    { label: "Agenda" },
  ],
};

export const EVENT_STATUS_OPTIONS = [
  { value: "upcoming", label: "À venir" },
  { value: "ongoing", label: "En cours" },
  { value: "past", label: "Passés" },
  { value: "all", label: "Tous" },
];

export const EVENT_LIMIT_OPTIONS = [6, 12, 24, 48];

export const EVENT_SORT_OPTIONS = [
  { value: "start_date", label: "Date de début" },
  { value: "end_date", label: "Date de fin" },
  { value: "created_at", label: "Date de création" },
  { value: "title", label: "Titre" },
];

export const EVENT_DIR_OPTIONS = [
  { value: "ASC", label: "Ascendant" },
  { value: "DESC", label: "Descendant" },
];